import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getMortarSaleStatistics, getMortarReceiveStatistics } from '@/service/production/ProReportMortar';
export default function useProData(params) {
  var receivingData = ref({
    list: [],
    name: '',
    sumTotal: 0,
    sumWeight: 0
  });
  var saleData = ref([]);
  // 获取砂浆原材料采购统计
  var getMortarReceiveStatisticsAsyc = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getMortarReceiveStatistics(params.value);
          case 2:
            data = _context.sent;
            receivingData.value = data;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getMortarReceiveStatisticsAsyc() {
      return _ref.apply(this, arguments);
    };
  }();
  //获取砂浆销售统计
  var getMortarSaleStatisticsAsyc = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getMortarSaleStatistics(params.value);
          case 2:
            data = _context2.sent;
            saleData.value = data.list;
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getMortarSaleStatisticsAsyc() {
      return _ref2.apply(this, arguments);
    };
  }();
  return [receivingData, saleData, getMortarReceiveStatisticsAsyc, getMortarSaleStatisticsAsyc];
}